var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledProperty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_54004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5417 13.2472V17.4972H15.375C16.5486 17.4972 17.5 16.5458 17.5 15.3722V8.91153C17.5002 8.54354 17.3572 8.18993 17.1012 7.92553L11.0818 1.41805C10.0197 0.268889 8.22713 0.198333 7.07797 1.26043C7.02339 1.3109 6.97079 1.36346 6.92036 1.41805L0.911553 7.9234C0.647854 8.1889 0.4999 8.54796 0.5 8.92216V15.3722C0.5 16.5458 1.4514 17.4972 2.625 17.4972H5.45832V13.2472C5.47157 11.3157 7.03102 9.73845 8.91387 9.69303C10.8597 9.64608 12.5268 11.2502 12.5417 13.2472Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_54004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledProperty);
export default __webpack_public_path__ + "static/media/FilledProperty.3f8cfc6330f1b06be08ce7174ce84088.svg";
export { ForwardRef as ReactComponent };